import { SALES_SIMULATOR_ML_PATH } from './constants';

export const SELLER_AREA_HOME_PATH = SALES_SIMULATOR_ML_PATH;
